import { type ReactNode } from 'react'
import styles from './Section.module.css'

interface SectionProps {
  title: string
  children: ReactNode
}

export function Section({ title, children }: SectionProps) {
  return (
    <div className={styles['section']}>
      <h3 className={styles['title']}>{title}</h3>
      {children}
    </div>
  )
}
